// @breezystack/lamejs is a fork that fixes the "MPEGMode is not defined" bug
// and supports ES modules natively
import lamejs from '@breezystack/lamejs';

export const Mp3Encoder = lamejs.Mp3Encoder;
